import React, { ComponentProps, useState } from "react";
import classnames from "classnames";
// Components
import IconWrapper from "@vahak/core-ui/dist/components/IconWrapper";
import Flex from "@vahak/core-ui/dist/layout/Flex";
import Working from "./modal/Working";
import Typography from "@vahak/core-ui/dist/components/Typography";
import Button from "@vahak/core-ui/dist/components/Button";
// Constants
import COLORS from "@vahak/core-ui/dist/constants/colors";
// Methods
// Hooks
import { useToggleModalWithLocalState } from "@vahak/core-ui/dist/hooks";
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";
// Assets
import Styles from "./HowItWorksBtn.module.scss";
import InfoIcon from "@vahak/core/dist/icons/info_grey.svg";

interface HowItWorksBtnProps
    extends Pick<ComponentProps<typeof Working>, "isPaidBookingRequired" | "isTapNgoLoad" | "isSpotLoad"> {
    responsive?: boolean;
    workingListType: ComponentProps<typeof Working>["type"];
}

const HowItWorksBtn = ({ responsive, workingListType, ...restProps }: HowItWorksBtnProps) => {
    const { isModalOpen, toggleModal } = useToggleModalWithLocalState(false);
    const isMobileScreen = useMediaQuery({ queryType: "mobile" }) && responsive;
    return (
        <span className={classnames(Styles.main, responsive && Styles.responsive)} onClick={(e) => e.stopPropagation()}>
            <Button onClick={toggleModal} fillType="text">
                <Flex alignItems="center" gap={5}>
                    <IconWrapper width={16} height={16} svgFillColor={COLORS.BLUE}>
                        <InfoIcon />
                        {!isMobileScreen && (
                            <Typography size="s" color={COLORS.BLUE}>
                                &nbsp; How it works
                            </Typography>
                        )}
                    </IconWrapper>
                </Flex>
            </Button>
            {isModalOpen && <Working type={workingListType} toggleModal={toggleModal} {...restProps} />}
        </span>
    );
};

export default HowItWorksBtn;
